import { Router } from '@reach/router';
import { GrvProvider } from '@c1/gravity-react';
import NotFoundPage from 'src/pages/NotFoundPage/NotFoundPage';
import PageTemplate from 'src/pages/PageTemplate/PageTemplate';
import { FunctionComponentReturnType } from 'src/types/sharedReact';
import { CLIENT_PATHS, getBasePathForHostname } from 'src/utils/routing/routes';
import AuthenticationProvider from 'src/contextProviders/AuthenticationProvider/AuthenticationProvider';
import NavigationPaneProvider from 'src/contextProviders/NavigationPaneProvider/NavigationPaneProvider';
import { pageMetadatas, } from 'src/utils/routing/pageMetadatas';
import { PageMetadata } from 'src/utils/routing/PageMetadata';
import { FEATURES } from 'src/utils/feature';

function App(): FunctionComponentReturnType {
    return (
        <AuthenticationProvider>
            <NavigationPaneProvider>
                <GrvProvider autoGenerateId>
                    <Router basepath={"/"}>
                        {
                            Object.values(pageMetadatas).map((
                                {
                                    Page,
                                    path,
                                    requiredFeatures
                                }: PageMetadata
                            ) => {
                                return <PageTemplate
                                    key={Page.name}
                                    Page={Page}
                                    path={path}
                                    requiredFeatures={requiredFeatures}
                                />;
                            })
                        }

                        <PageTemplate
                            Page={NotFoundPage}
                            requiredFeatures={[FEATURES.NO_FEATURE_REQUIRED]}
                            default
                        />
                    </Router>
                </GrvProvider>
            </NavigationPaneProvider>
        </AuthenticationProvider>
    );
}

export default App;
